"use strict";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackMessage = void 0;
var raw_1 = require("@tableau/icons/NotificationInfoOutlineIcon/raw");
var ThumbDownIcon_1 = require("@tableau/icons/ThumbDownIcon");
var ThumbUpIcon_1 = require("@tableau/icons/ThumbUpIcon");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importStar(require("react"));
var typestyle_1 = require("typestyle");
var Localize_1 = require("../gen-src/Localize");
var FeedbackReducer_1 = require("./FeedbackReducer");
var ICON_COLOR_DEFAULT = '#666666'; // TabStyles.Colors.L8
var ICON_COLOR_SELECTED = '#333333'; // TabStyles.Colors.L9
var MAX_FEEDBACK_CHARS = 400;
var infoIcon = raw_1.NotificationInfoOutlineIconRaw(14);
var button = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 18,
    width: 18,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    borderRadius: 2,
};
var buttonClass = typestyle_1.style(button, {
    $debugName: 'feedback-thumb-base',
});
var selectedClass = typestyle_1.style(__assign(__assign({}, button), { backgroundColor: '#CCCCCC' }), {
    $debugName: 'feedback-thumb-selected',
});
function FeedbackMessage(_a) {
    var onSubmitUserFeedback = _a.onSubmitUserFeedback;
    var _b = FeedbackReducer_1.useFeedbackReducer(), state = _b[0], dispatch = _b[1];
    var NegativeFeedbackCheckboxOptions = {
        BiasedToxicHarmful: Localize_1.Messages.TableauGPTBiasedFeedback(),
        Inaccurate: Localize_1.Messages.TableauGPTInaccurateFeedback(),
        Incomplete: Localize_1.Messages.TableauGPTIncompleteFeedback(),
        Inappropriate: Localize_1.Messages.TableauGPTInappropriateFeedback(),
        Other: Localize_1.Messages.TableauGPTOtherFeedback(),
    };
    var negativeFeedbackPopoverRef = react_1.useRef(null);
    var positiveFeedbackPopoverRef = react_1.useRef(null);
    var textareaRef = react_1.useRef(null);
    var _c = widgets_1.getMaxCharValidation(state.feedbackText, MAX_FEEDBACK_CHARS), message = _c.message, valid = _c.valid;
    var selectThumbsUp = function () {
        dispatch({ type: 'click_thumbs_up' });
    };
    var selectThumbsDown = function () {
        dispatch({ type: 'click_thumbs_down' });
    };
    var isThumbsUpSelected = state.feedback === 'GOOD';
    var isThumbsDownSelected = state.feedback === 'BAD';
    var ThumbsUpFeedbackPopoverTrigger = (react_1.default.createElement("span", { className: isThumbsUpSelected ? selectedClass : buttonClass, onClick: function () { return selectThumbsUp(); }, title: Localize_1.Messages.TableauGPTThumbsUpHoverTooltip() },
        react_1.default.createElement(ThumbUpIcon_1.ThumbUpIcon, { size: 14, color: isThumbsUpSelected ? ICON_COLOR_SELECTED : ICON_COLOR_DEFAULT })));
    var TextAreaFeedback = (react_1.default.createElement(widgets_1.TextAreaWidget, { maxLength: 400, label: Localize_1.Messages.TableauGPTTellUsMore(), testId: "additional-feedback", placeholder: Localize_1.Messages.TableauGPTFeedbackPlaceholder(), message: message, rows: 2, style: { width: '264px', resize: 'none' }, valid: valid, value: state.feedbackText, onChange: function (e) { return dispatch({ type: 'text', feedbackText: e.target.value }); }, ref: textareaRef }));
    var ThumbsUpPopoverContent = TextAreaFeedback;
    var ThumbsDownFeedbackPopoverTrigger = (react_1.default.createElement("span", { className: isThumbsDownSelected ? selectedClass : buttonClass, onClick: function () { return selectThumbsDown(); } },
        react_1.default.createElement(ThumbDownIcon_1.ThumbDownIcon, { size: 14, color: isThumbsDownSelected ? ICON_COLOR_SELECTED : ICON_COLOR_DEFAULT })));
    var ThumbsDownPopoverContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "group-label", style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: widgets_1.TabStyles.Spacing.SmallSpace,
                marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
            } },
            react_1.default.createElement("span", null, Localize_1.Messages.TableauGPTNegativeFeedbackCheckboxGroupTitle()),
            react_1.default.createElement(widgets_1.Tooltip, { position: widgets_1.TooltipPosition.Top, getContent: function () { return react_1.default.createElement("span", null, Localize_1.Messages.TableauGPTNegativeFeedbackTooltip()); } },
                react_1.default.createElement("img", { width: 14, height: 14, color: ICON_COLOR_DEFAULT, src: "data:image/svg+xml," + encodeURIComponent(infoIcon), alt: "info icon" }))),
        react_1.default.createElement(widgets_1.CheckBoxWithLabelGroupWidget, { "aria-labelledby": "additional-feedback-options", style: { marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace } },
            react_1.default.createElement(widgets_1.CheckBoxWithLabelWidget, { checked: state.biasedToxicHarmful, onChange: function () { return dispatch({ type: 'click_toxic' }); }, label: NegativeFeedbackCheckboxOptions.BiasedToxicHarmful, testId: "biasedToxicHarmfulFeedbackCheckbox" }),
            react_1.default.createElement(widgets_1.CheckBoxWithLabelWidget, { checked: state.inaccurate, onChange: function () { return dispatch({ type: 'click_inaccurate' }); }, label: NegativeFeedbackCheckboxOptions.Inaccurate, testId: "inaccurateFeedbackCheckbox" }),
            react_1.default.createElement(widgets_1.CheckBoxWithLabelWidget, { checked: state.incomplete, onChange: function () { return dispatch({ type: 'click_incomplete' }); }, label: NegativeFeedbackCheckboxOptions.Incomplete, testId: "incompleteFeedbackCheckbox" }),
            react_1.default.createElement(widgets_1.CheckBoxWithLabelWidget, { checked: state.inappropriate, onChange: function () { return dispatch({ type: 'click_inappropriate' }); }, label: NegativeFeedbackCheckboxOptions.Inappropriate, testId: "inappropriateFeedbackCheckbox" }),
            react_1.default.createElement(widgets_1.CheckBoxWithLabelWidget, { checked: state.other, onChange: function () { return dispatch({ type: 'click_other' }); }, label: NegativeFeedbackCheckboxOptions.Other, testId: "otherFeedbackCheckbox" })),
        TextAreaFeedback));
    var commonPopoverProps = function (ref) {
        var commonProps = {
            placement: 'bottom-start',
            title: react_1.default.createElement("span", null, Localize_1.Messages.TableauGPTFeedbackHeader()),
            showTitleBar: true,
            footerButtons: [
                {
                    children: Localize_1.Messages.TableauGPTFeedbackSubmitButton(),
                    onClick: function () {
                        var _a;
                        if (onSubmitUserFeedback) {
                            onSubmitUserFeedback(state);
                        }
                        dispatch({ type: 'reset' });
                        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.toggle();
                    },
                    disabled: valid === 'pending' || valid === false,
                    buttonType: widgets_1.ButtonType.Primary,
                },
            ],
            width: 300,
        };
        return commonProps;
    };
    /**
     * The disableAutoFocus usage below causes the popover to autofocus the text area when it opens.
     * By default, the popover will autofocus the first focusable element in the popover, which is the info icon.
     **/
    return (react_1.default.createElement("p", { style: { display: 'flex', flexDirection: 'row', gap: '10px' } },
        react_1.default.createElement("span", null, Localize_1.Messages.TableauGPTAssistantFeedbackMessage()),
        react_1.default.createElement(widgets_1.PopoverWidget, __assign({}, commonPopoverProps(positiveFeedbackPopoverRef), { popoverContent: ThumbsUpPopoverContent, triggerElement: ThumbsUpFeedbackPopoverTrigger, ref: positiveFeedbackPopoverRef, testId: "thumbs-up-button" })),
        react_1.default.createElement(widgets_1.PopoverWidget, __assign({}, commonPopoverProps(negativeFeedbackPopoverRef), { 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            disableAutoFocus: function () { return textareaRef.current; }, popoverContent: ThumbsDownPopoverContent, triggerElement: ThumbsDownFeedbackPopoverTrigger, ref: negativeFeedbackPopoverRef, testId: "thumbs-down-button" }))));
}
exports.FeedbackMessage = FeedbackMessage;
//# sourceMappingURL=FeedbackMessage.js.map